import { useFormContext } from '@/Hooks/useFormWrapper';
import { FormData } from '@/ModalWindows/OrderAutomatizationModal/hooks/useOrderAutomatizationModalForm';
import { useFieldArray } from 'react-hook-form';
import { useRequired } from '@/Hooks/Validation';
import { useState } from 'react';
import { Nullable } from '@/Types';
import { OrderAutomatizationProductModel } from '@/Models/OrderUserProducts/OrderAutomatizationProductModel';

export const useLogisticContractForm = (rowIndex: number) => {
  // Form
  const {
    register,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useFormContext<FormData>();

  const { append, remove, fields } = useFieldArray({
    name: `prepareLabels.${rowIndex}.packages`,
    control: control,
    keyName: 'array_id',
  });

  // Rules
  const required = useRequired();

  // Packages
  const packages = watch(`prepareLabels.${rowIndex}.packages`);

  const selectedPackages = fields.map((field, idx) => {
    return { ...field, ...packages[idx] };
  });

  // Product
  const [logisticProduct, setLogisticProduct] = useState<Nullable<OrderAutomatizationProductModel>>(null);

  const onResetProduct = () => {
    setLogisticProduct(null);
    setValue(`prepareLabels.${rowIndex}.userProductId`, '');
  };

  const onSelectProduct = (product: OrderAutomatizationProductModel) => {
    setLogisticProduct(product);
    setValue(`prepareLabels.${rowIndex}.userProductId`, product.id);
    setValue(`prepareLabels.${rowIndex}.deliveryDate`, product.deliveryDate);
    setValue(`prepareLabels.${rowIndex}.userProductPrice`, product.userProductPrice);
    setValue(`prepareLabels.${rowIndex}.logisticTypeId`, product.logisticTypeId);
  };

  return {
    methods: {
      register,
      setValue,
      errors,
      watch,
    },
    rules: {
      required,
    },
    packages: {
      packages: selectedPackages,
      append,
      remove,
    },
    logisticProduct: {
      logisticProduct,
      setLogisticProduct,
      onSelectProduct,
      onResetProduct,
    },
  };
};
